import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function PortabilityCheck() {
  return (
    <Page
      title='Portability Check'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'Portability Check',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/portability-check',
  component: PortabilityCheck,
  type: 'auth',
});
